import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { ContentControlApplicationRule } from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../../utils/translator.helper';

// validate duplicates
export function validateDuplicates(
  exclusionItem: ContentControlApplicationRule,
  exclusionsInGrid: ContentControlApplicationRule[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ContentControlApplicationRule) => exclusionInGrid.appPath === exclusionItem.appPath
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
